import * as t from 'io-ts'

export type Classifier = t.TypeOf<typeof Classifier>

export interface Group {
  id: number
  // type: 'group'
  name: string
  children: Group[]
}

export const Group: t.Type<Group> = t.recursion('Group', () =>
  t.type({
    id: t.number,
    // type: t.literal('group'),
    name: t.string,
    children: t.array(Group),
  })
)

export const Classifier = t.type({
  id: t.number,
  type: t.literal('classifier'),
  name: t.string,
  children: t.array(Group),
})
